module.exports = __webpack_public_path__ + "img/solution_img.78f449f0.png";